import { render } from "./GerirAtendimentoProfissional.vue?vue&type=template&id=44279c33&scoped=true"
import script from "./GerirAtendimentoProfissional.vue?vue&type=script&lang=js"
export * from "./GerirAtendimentoProfissional.vue?vue&type=script&lang=js"

import "./GerirAtendimentoProfissional.vue?vue&type=style&index=0&id=44279c33&scoped=true&lang=css"

import exportComponent from "/builds/ssp/csmpmview/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44279c33"]])

export default __exports__